import { Entry } from '../types'

const PACKAGES: Entry[] = [
  {
    id: 'fusejs',
    title: 'fuse.js',
    description: 'Client-side Fuzzy Search',
    links: {
      website: 'https://fusejs.io/',
      github: 'https://github.com/krisk/fuse',
    },
    tags: ['javascript', 'search', 'fuzzy'],
  },
  {
    id: 'badger-accordion',
    title: 'Badger Accordion',
    links: {
      github: 'https://github.com/stuartjnelson/badger-accordion',
      demo: 'https://codepen.io/stuartjnelson/full/WZpxqY',
    },
    tags: ['javascript', 'accordion'],
  },
  {
    id: 'notyf',
    title: 'Notyf',
    description: 'JavaScript library to show toast notifications.',
    links: {
      website: 'https://carlosroso.com/notyf',
      github: 'https://github.com/caroso1222/notyf',
    },
    tags: ['javascript', 'snackbar', 'toast'],
  },
  {
    id: 'reacthookform',
    title: 'react-hook-form',
    description: 'Performant, flexible and extensible forms with easy-to-use validation.',
    links: {
      website: 'https://react-hook-form.com/',
      github: 'https://github.com/react-hook-form/react-hook-form',
    },
    tags: ['javascript', 'react', 'forms'],
  },
  {
    id: 'codedoc',
    title: 'codedoc',
    description:
      'CODEDOC is an open-source tool that helps you with creating beautiful and modern software documentation. It creates a JAMStack app from your markdown files.',
    links: {
      website: 'https://codedoc.cc/',
      github: 'https://github.com/CONNECT-platform/codedoc',
    },
    tags: ['javascript', 'snippets', 'markdown'],
  },
].map((item) => ({
  ...item,
  type: 'package',
}))

export default PACKAGES
